var include_seven_app_bnr = `
<a href="/how-to/group/sej.html" class="conversion-btn__bnr conversion-btn__bnr--pc-wise">
    <img src="/material/img/common/bnr/bnr_seven_app.png" alt="セブン‐イレブンアプリからApple Payのnanacoでお支払いが可能に！" class="conversion-btn__bnr-img pc-only">
    <img src="/material/img/common/bnr/bnr_seven_app_sp.png" alt="セブン‐イレブンアプリからApple Payのnanacoでお支払いが可能に！" class="sp-only">
</a>
`;
